<template>
  <li class="dropdown">
    <PopperIcon icon="zmdi-more-vert">
      <ul class="base-dropdown-menu">
        <slot />
        <li v-if="$slots.default" role="separator" class="divider" />
        <li class="clickable" @click.stop="$emit('toggle-grid')">
          <a>
            {{ $t('Show grid') }}
            <i v-if="showGrid" class="fa fa-check c-gray" />
          </a>
        </li>
        <li role="separator" class="divider" />
        <li
          v-for="type of chartOptions"
          :key="type"
          :class="{ disabled: disabled(type), clickable: !disabled(type) }"
          @click.stop="clickEvent(type)"
        >
          <a>
            {{ $t(type + ' chart') }}
            <i v-if="chartType === type" class="fa fa-check c-gray" />
          </a>
        </li>
      </ul>
    </PopperIcon>
  </li>
</template>

<script>
import { PropChartType } from '@/mixins/PropChartType'
import { ChartTypes } from '@/utils/enum'
import PopperIcon from '@/components/PopperIcon.vue'

export default {
  name: 'DataVisDropdown',
  components: { PopperIcon },
  mixins: [PropChartType],
  props: {
    showGrid: {
      type: Boolean,
      required: true,
    },
    icon: {
      type: [String, Object, Array],
      default: 'zmdi-more-vert',
    },
    multipleDatasets: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default -- Baseline eslint ignore please fix if working on this
      default: true,
    },
  },
  emits: ['toggle-grid', 'update:chartType'],
  data() {
    return {
      initialChartType: this.chartType,
      ChartOnlyMultiDataSetEnabled: {
        [ChartTypes.Line]: false,
        [ChartTypes.Bar]: false,
        [ChartTypes.Stacked]: true,
        [ChartTypes.StackedPercentage]: true,
        [ChartTypes.Doughnut]: true,
      },
    }
  },
  computed: {
    chartOptions() {
      return Object.values(ChartTypes)
    },
  },
  methods: {
    clickEvent(type) {
      if (!this.disabled(type)) {
        this.$emit('update:chartType', type)
      }
    },
    disabled(type) {
      return !this.multipleDatasets && this.ChartOnlyMultiDataSetEnabled[type]
    },
  },
}
</script>

<style scoped>
li:hover.disabled,
li:hover.disabled a,
.disabled a:hover {
  color: #777777 !important;
  text-decoration: none;
  cursor: not-allowed;
  background-color: initial;
}
</style>
